import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import WishVotesBox from './components/WishVotesBox';
export default function addSidebarBox() {
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    // `discussion` is protected on the page; core also puts it on app.current.
    const discussion = app.current.get('discussion');

    // Below flarum/subscriptions' Follow button (80), so Reply and Follow stay together.
    if (discussion && (discussion.isOpenWish() || discussion.wishVoteCount() > 0)) {
      items.add('wishVotes', m(WishVotesBox, {
        discussion: discussion
      }), 70);
    }
  });
}